import placeholderSvg from "@/assets/svg/placeholder.svg";
import { FileViewer, PreviewFile } from "./file-viewer";

interface FileThumbnailProps {
  file: PreviewFile;
  onClick: () => void;
}

export const FileThumbnail = ({ file, onClick }: FileThumbnailProps) => (
  <button
    onClick={onClick}
    className="relative flex aspect-square w-full items-center justify-center rounded-md border"
  >
    <FileViewer
      file={file}
      className="w-full h-full object-cover rounded-md"
      fallback={
        <img
          alt={file.name}
          className="w-full h-full rounded-md object-cover"
          src={placeholderSvg}
        />
      }
    />
    <span className="absolute bottom-2 left-2 text-xs bg-black bg-opacity-50 text-white p-1 rounded">
      {file.name}
    </span>
  </button>
);
